module.exports = __webpack_public_path__ + "static/company-actions-7a29f008186098b4bd5115f747a0f778.png";